import { Stack } from '@chakra-ui/react';
import { useTranslation } from 'i18n/TranslationProvider';
import AllTrucksList from '../components/AllTrucks/AllTrucks';
import { PageHeader, PageShell } from 'components/layout/PageShell';

const AdminAllTrucksPage = () => {
  const { t } = useTranslation();

  return (
    <PageShell>
      <Stack spacing={6}>
        <PageHeader
          title={t('Manage All Trucks')}
          description={t('Monitor fleet compliance, validation status, and expiring insurance in one place.')}
        />
        <AllTrucksList />
      </Stack>
    </PageShell>
  );
};
export default AdminAllTrucksPage;
